import React, { Component } from "react";
import "../css/ChangeDeliveryAddress.css";
import { lockBody, unlockBody } from "../function/bodyLockStatus";
import { Translation } from "react-i18next";

class ChangeDeliveryAddress extends Component {
  state = { displayStatus: false };

  componentDidUpdate(prevProps) {
    const {
      deliveryOption: {
        delivery_area: { value }
      }
    } = this.props;
    if (value !== prevProps.deliveryOption.delivery_area.value) {
      if (value === "CN") {
        this.setState({ displayStatus: true });
        lockBody();
      }
    }
  }

  closeDialog = () => {
    const { clear } = this.props;
    clear();
    this.setState({ displayStatus: false });
    unlockBody();
  };

  closeDialogFromBg = e => {
    const { className } = e.target;
    const { clear } = this.props;
    if (className === "changeDeliveryAddress-bg") {
      clear();
      this.setState({ displayStatus: false });
      unlockBody();
    }
  };

  goCnPage = () => {
    window.location = "https://cn.emphasis.com/";
  };

  render() {
    const { displayStatus } = this.state;
    return (
      <div
        style={{
          opacity: displayStatus ? "1" : "0",
          pointerEvents: displayStatus ? "" : "none"
        }}
        className="changeDeliveryAddress-bg"
        onClick={this.closeDialogFromBg}
      >
        <div
          style={{
            transform: displayStatus ? "translateY(0px)" : "translateY(-10px)"
          }}
          className="changeDeliveryAddress"
        >
          <div className="changeDeliveryAddressPage">
            <div className="changeDeliveryAddressHeader">
              <h1>
                <Translation>
                  {t => <>{t("changeDelivery.changeDestination")}</>}
                </Translation>
              </h1>
              <div
                className="close-button-change-delivery"
                onClick={this.closeDialog}
              />
            </div>
            <div className="changeDeliveryAddressPrompt">
              <p>
                <Translation>
                  {t => <>{t("changeDelivery.text")}</>}
                </Translation>
              </p>
              <div className="changeDeliveryAddressButtons">
                <div className="carryOnButton">
                  <button onClick={this.goCnPage}>
                    <Translation>
                      {t => <>{t("changeDelivery.continue")}</>}
                    </Translation>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChangeDeliveryAddress;
